export default "__VITE_ASSET__BsYJoz1A__"